import styled from 'styled-components';
import * as colors from '../../../../common/colorConstants';
import {
  mediumHeightScreens,
  smallScreens,
  mediumScreens,
  lowHeightScreens,
  extraSmallScreens,
} from '../../../../common/fontElements';

export const Container = styled.div`
  position: relative;
  height: 100%;
  flex-direction: column;
  display: flex;
`;

export const HeaderContainer = styled.div`
  padding: 30px 40px 30px;
  border-bottom: 1px solid ${colors.lightGray15};
  @media (max-height: ${smallScreens}) {
    padding: 20px 40px 20px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    padding: 10px 40px 15px;
  }
`;

export const Title = styled.p`
  font-family: Lato;
  font-size: 14px;
  color: ${colors.darkGray9};
  margin: 0px;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
  }
`;

export const SpinnerWrapper = styled.div`
  width: 100%;
`;

export const CenterPos = styled.div`
  margin: 0 auto;
  display: flex;
`;

export const HeaderRow = styled.div`
  display: flex;
  padding: 5px 0 5px 32px;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  background: ${colors.lightGray7};
  color: ${colors.darkGray14};
  border-top: 1px solid ${colors.lightGray21};
  border-bottom: 1px solid ${colors.lightGray21};
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    padding: 15px 40px 8px 55px;
  }
`;

export const ResultsColumnHeader = styled.div`
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  min-width: ${(props) => props.$width || '100%'};
  display: flex;
  align-items: center;
  font-size: 9px;
  padding-right: 30px;
  justify-content: ${(props) => props.$justifyContent || 'initial'};
`;

export const TitleText = styled.p`
  font-size: 12px;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0;
  text-align: left;
  margin: 10px;
  @media screen and (max-width: ${mediumScreens}) {
    font-size: 13px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 12px;
  }

  padding: 0 0 7px 30px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  line-height: 18px;
  color: ${colors.lightBlack};
`;

export const Row = styled.div`
  display: flex;
  padding: 15px 0 15px 32px;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0;
  border-bottom: 1px solid #d8e8ef;
  background: ${({ open }) => (open ? colors.lightGray7 : colors.white)};
  @media screen and (max-height: ${smallScreens}), screen and (max-width: ${smallScreens}) {
    padding: 10px 40px 10px 55px;
  }
`;

export const DetailsButton = styled.button`
  border-radius: 3px;
  width: 18px;
  height: 18px;
  background-color: ${colors.white};
  background-repeat: no-repeat;
  background-position: center;
  background-size: 8px;
  background-image: url(${({ open }) => `/images/arrows/down-arrow-${open ? 'blue' : 'gray'}.svg`});
  transform: ${({ open }) => (open ? `rotateX(180deg)` : `rotateX(0)`)};
  border: 1px solid ${({ open }) => (open ? colors.blue1 : colors.lightGray1)};
`;

export const ResultsColumn = styled.div`
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  min-width: ${(props) => props.$width || '100%'};
  display: flex;
  font-size: 11px;
  align-items: flex-start;
  white-space: pre-wrap;
  word-break: break-word;
  text-overflow: ellipsis;
  padding-right: 30px;
  justify-content: ${(props) => props.$justifyContent || 'initial'};
  @media screen and (max-height: ${extraSmallScreens}), screen and (max-width: ${extraSmallScreens}) {
    font-size: 9px;
  }
`;

export const TitleTextLight = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
  color: ${colors.darkGray1};
`;

export const TitleWrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
